import React from 'react';
import AlertHeadline from '../../common/AlertHeadline/AlertHeadline.js';
import './AlertSection.css';

const AlertSection = (props) => {
   return (
     <div className="AlertSection-container">
       <AlertHeadline {...props} />
     </div>
   )
 }

 export default AlertSection;


// WEBPACK FOOTER //
// ./src/containers/AlertSection/AlertSection.js